function kkhybrid_checkinmessageupdate (opt) {
  hybrid({
    hybridParam: {
      schema: "kkhybrid",
      tagname: "checkinmessageupdate",
    },
    param: {
      status: opt.status,
      time: opt.time
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}
function kkmhhybrid_notice_checkinmessageupdate (opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "notice_checkinmessageupdate",
    },
    param: {
      status: opt.status,
      time: opt.time
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

/**
 * 任务中心-勾选通知<br>
 * kkhybrid://checkinmessageupdate，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=43387219}<br>
 * kkmhhybrid://checkinmessageupdate，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=304907312}<br>
 * @param {Object} opt 参数对象
 * @param {Number} opt.status 勾选签到状态(0不提醒  1提醒)
 * @param {String} opt.time 通知时间
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置）
 */
function checkinmessageupdate (opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if (allow) {
    // 调用新协议
    kkmhhybrid_notice_checkinmessageupdate(opt);
  } else {
    // 调用旧协议
    kkhybrid_checkinmessageupdate(opt)
  }
}

export default checkinmessageupdate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kk/h5-sdk/src/checkinmessageupdate/index.js
// module id = null
// module chunks = 